import React from 'react';
import { TextAreaInput, TextInput } from '@prosolve/common-components-ui'

export default ({
  questionId,
  answers,
  setAnswers,
  validationRegex,
  validationNote,
  isSingleLineText,
  hasInvalidMark
}) => {

  const answerObj =  answers[questionId] || {};
  const {
    answerText = ''
  } = answerObj;

  const onUpdateAnswer = (val) => {
    const updateObj = { answerText: val }
    setAnswers({
      ...answers,
      [questionId]: updateObj
    })
  }

  return (
    <div style={{ position: 'relative'}}>
      {
        isSingleLineText ?
        <TextInput
          width='100%'
          style={{ fontSize: '16px' }}
          value={answerText}
          onChange={onUpdateAnswer}
          isInvalid={hasInvalidMark}
          placeholder=''
        /> :
        <TextAreaInput
          width='100%'
          style={{ fontSize: '16px' }}
          value={answerText}
          onChange={onUpdateAnswer}
          isInvalid={hasInvalidMark}
          placeholder=''
        />
      }
      {
        ( (Boolean(validationRegex) && Boolean(validationNote)) || hasInvalidMark ) &&
        <div style={{ position: 'absolute', bottom: '-20px', fontStyle: 'italic', fontSize: '15px', color: hasInvalidMark ? '#ef0c0c' : 'inherit' }}>
          {validationNote || '*Required'}
        </div>
      }
    </div>
  )
}